import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'mvtCardHouseList',
    props: {
        data: {
            type: Array,
            required: true,
        },
        isLink: {
            type: Boolean,
            default: false,
        },
        isMlsNumberSearch: {
            type: Boolean,
            default: false,
        },
        searchText: {
            type: String,
            default: '',
        },
    },
    inject: ['$eventBus', 'split'],
    data() {
        return {
            loading: false,
            fetchedList: [],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'popLeadBeforeRedirect']),
        title() {
            const first = this.houseList[0];
            const address = first?.geo.address;
            if (this.isMlsNumberSearch) {
                return first && first.mlsNumber;
            }
            return this.searchText || address.split('#')[0] || '-';
        },
        houseList() {
            if (this.fetchedList.length > 0) {
                const mergedData = this.data.map((property) => {
                    if (property.light && property.propertyId) {
                        const propertyLookup = this.fetchedList.find((fetchedProperty) => fetchedProperty.propertyId === property.propertyId);
                        if (propertyLookup) {
                            return propertyLookup;
                        }
                    }
                    return property;
                });
                return mergedData;
            }
            return this.data;
        },
    },
    watch: {
        title() {
            $(this.$refs['list']).scrollTop(0);
        },
    },
    methods: {
        ...mapActions('glb', ['getPropertyInfoById']),
        navigate(url) {
            if (url) {
                if (this.popLeadBeforeRedirect) {
                    this.$eventBus.$emit('eventbus-popLead-beforeRedirect', url);
                } else {
                    window.location.href = url;
                }
            }
        },
        fetchPropertyDetails() {
            const ids = this.data.reduce((acc, item) => {
                if (item.light && item.propertyId) {
                    acc.push(item.propertyId);
                }
                return acc;
            }, []);
            if (ids.length > 0) {
                this.loading = true;
                this.getPropertyInfoById({
                    propertyIds: ids,
                }).then((res) => {
                    if (res && res.length) {
                        this.fetchedList = res;
                    }
                    this.loading = false;
                });
            }
        },
    },
    beforeMount() {
        this.fetchPropertyDetails();
    },
};
